export const ADMINISTRATOR_FIELD_WIDTH = 352;
